import React from 'react'

const ReservationSummary = (props) => {
  const categories = props.summary.categories.map((c, index) =>
    <li key={index} style={{'backgroundColor': c.background_color, 'color': c.text_color}}>
      {`${c.name} (${c.count})`}
    </li>
  )

  return (
    <div id='reservationSummary' className={'row reservation-category-summary ' + (props.opened ? '' : 'summary-hidden')}>
      <ul className='col-lg-10 reservation-category-summary__categories'>
        {categories}
      </ul>
      <div className='col-lg-2 reservation-category-summary__total'>
        Total Reservations: <b>{props.summary.total_count}</b>
        <br />
        Total Hours: <b>{props.summary.total_hours}</b>
      </div>
    </div>
  )
}

export default ReservationSummary
